module.exports = __webpack_public_path__ + "static/media/arrow_left_square.bc53bd57.svg";